import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { base64ToFile, Dimensions, ImageCroppedEvent, ImageCropperModule} from 'ngx-image-cropper';
import {FileUploadModule} from 'primeng/fileupload';
import { ModalHeaderComponent } from '../../modals/components/modal-header/modal-header.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import {HttpClientModule} from '@angular/common/http';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-image-load-crop',
  standalone: true,
  imports: [
    CommonModule, HttpClientModule, TranslateModule,
    ImageCropperModule, FileUploadModule, ButtonModule,
    ModalHeaderComponent,
  ],
  templateUrl: './image-load-crop.component.html',
  styleUrls: ['./image-load-crop.component.scss']
})
export class ImageLoadCropComponent implements OnInit {

  @Input() aspectRatio: number = 1 / 1;
  @Input() maintainAspectRatio: boolean = true;
  @Input() containWithinAspectRatio: boolean = false;
  @Input() triggerFileInput$: Subject<void> = new Subject();
  triggerFileInputSub: Subscription = Subscription.EMPTY;

  @Output() editedImageBase64: EventEmitter<any> = new EventEmitter();

  imageChangedEvent: any = '';
  croppedImage: any = '';
  rotation = 0;
  scale = 1;

  modalEl: TemplateRef<any> | undefined;
  modalRef: NgbModalRef | undefined;

  @ViewChild('fileInput') fileInput: ElementRef | undefined;

  constructor(
    private ngbModalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.triggerFileInputSub = this.triggerFileInput$.subscribe(() => {
      this.fileInput?.nativeElement.click();
    });
  }

  onDone() {
    this.editedImageBase64.emit(this.croppedImage);
    this.close();
  }

  close() {
    this.modalRef?.close();
  }

  fileChangeEvent(event: any, modalEl: any): void {
    this.modalEl = modalEl;
    this.modalRef = this.ngbModalService.open(this.modalEl, { size: 'lg' });
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {

  }

  cropperReady(sourceImageDimensions: Dimensions) {
  }

  loadImageFailed() {
  }

  ngOnDestroy(): void {
    this.triggerFileInputSub.unsubscribe();
  }

}
